webpackJsonp([26076085654735],{

/***/ 1372:
/***/ (function(module, exports) {

	module.exports = {"pathContext":{"name":"HospitalQueries","kind":"OBJECT","type":"QUERY","fields":[{"args":[{"defaultValue":null,"description":null,"name":"careTeamId","type":{"kind":"SCALAR","name":"ID","ofType":null}},{"defaultValue":null,"description":null,"name":"departmentIds","type":{"kind":"LIST","name":null,"ofType":{"kind":"SCALAR","name":"ID","ofType":null}}},{"defaultValue":"true","description":null,"name":"isActive","type":{"kind":"SCALAR","name":"Boolean","ofType":null}},{"defaultValue":null,"description":null,"name":"locationId","type":{"kind":"SCALAR","name":"ID","ofType":null}}],"deprecationReason":null,"description":null,"isDeprecated":false,"name":"hospitalizations","type":{"kind":"LIST","name":null,"ofType":{"kind":"OBJECT","name":"Hospitalization","ofType":null}}}],"description":null}}

/***/ })

});


// WEBPACK FOOTER //
// path---query-hospital-queries-b6f03bc37d38401d0b8b.js